import React, { useState, type SyntheticEvent, useRef } from 'react';
import Button from '@atlaskit/button';
import EditIcon from '@atlaskit/icon/core/migration/edit';
import EditFilledIcon from '@atlaskit/icon/core/migration/edit--edit-filled';
import { token } from '@atlaskit/tokens';
import type { EditButtonProps } from './types.tsx';

export const EditButton = ({ onClick, shortcutId, id, label }: EditButtonProps) => {
	const [isHover, setIsHover] = useState(true);
	const buttonRef = useRef<HTMLButtonElement>(null);
	const onButtonClick = (event: SyntheticEvent) => {
		event.preventDefault();
		onClick(shortcutId, buttonRef);
	};

	return (
		<Button
			appearance="subtle-link"
			aria-label={label}
			spacing="none"
			onClick={onButtonClick}
			onMouseEnter={() => setIsHover(true)}
			onMouseLeave={() => setIsHover(false)}
			onFocus={() => setIsHover(true)}
			onBlur={() => setIsHover(false)}
			id={id}
			ref={buttonRef}
		>
			{isHover ? (
				<EditFilledIcon
					color={token('color.icon')}
					LEGACY_size="medium"
					spacing="spacious"
					label=""
				/>
			) : (
				<EditIcon color={token('color.icon')} LEGACY_size="medium" spacing="spacious" label="" />
			)}
		</Button>
	);
};
